import React from "react";
import { useAuth } from "../../context/AuthProvider";
import { roleUser } from "../../utils/constants";
import NotFound from "../module/404";

/**
 * Restrict a route component to the allowed roles.
 * Renders the existing 404 page when the current user's role
 * (from AuthProvider / JWT claim) is not in `allow`.
 *
 * UI-level gate only — server-side enforcement is a separate concern.
 */
export default function RoleGate({ allow = [roleUser.ROLE_OWNER], children }) {
  const { role } = useAuth();

  if (!allow.includes(role)) {
    return <NotFound />;
  }
  return children;
}
